import React from 'react/addons';
import _ from 'underscore';
import $ from 'jquery';
import moment from 'moment';
import {gettext, interpolate} from 'ofs/i18n';
import settings from 'ofs/settings';
import Icon from 'ofs/components/common/Icon';

import PrestayContentSection from 'ofs/apps/bookings/prestay/views/PrestayContentSection';
import Appointments from '../views/Appointments';
import SaveButton from '../views/SaveButton';

import Row from 'ofs/forms/layout/row';
import Column from 'ofs/forms/layout/column';
import FieldContainer from 'ofs/react/fields/fieldcontainer';
import Field from 'ofs/react/fields/field';
import RadioField from 'ofs/react/fields/radiofield';
import Datepicker from 'ofs/react/components/datepicker';
import TimeField from 'ofs/react/fields/timefield';
import TextField from 'ofs/react/fields/textfield';
import SelectField from 'ofs/react/fields/selectfield';
import PhoneNumberField from 'ofs/react/fields/phonenumberfield';

const messages = {
  ADD_TO_BILL: gettext("Yes please add %(currency)s%(amount)s to my bill"),
  AIRPORT: gettext("Airport"),
  ARRANGE_PICKUP: gettext("Would you like us to arrange a pick up?"),
  ARRIVAL_AT_THE_HOME: gettext("Arrival at the home"),
  ARRIVAL_MOBILE_NUMBER: gettext("What is your mobile number for arrival?"),
  ANOTHER_METHOD: gettext("Another method"),
  BY_TRAIN: gettext("By train"),
  CAR_TAXI: gettext("Car/Taxi"),
  CALCULATE_ARRIVAL: gettext("Calculate arrival time"),
  CHECK: gettext("Check"),
  CHECKING: gettext("Checking"),
  DIFFERENT_ARRIVAL_TIME_AT_HOME: gettext("Getting to the home at a different time?"),
  DRIVING: gettext("Driving"),
  ENTER_MANUALLY: gettext("Please enter your details manually"),
  ESTIMATE: gettext("We know estimating is tricky. Please take a shot and keep us updated on the day \u2013 so someone can meet you."),
  ESTIMATE_YOUR_ARRIVAL_TIME: gettext("Please estimate your arrival time below to get your appointment."),
  ESTIMATED_ARRIVAL: gettext("Estimated arrival time at the home"),
  FIND_APPOINTMENTS: gettext("Find available appointments"),
  FLIGHT_ARRIVAL_TIME: gettext("Flight arrival time"),
  FLIGHT_NUMBER: gettext("Flight number"),
  FLYING_IN: gettext("Flying in"),
  GET_TO_CITY: gettext("How will you be getting to %(city)s?"),
  GET_TO_HOME: gettext("How will you get to the home"),
  GREETERS_WILL_MEET: gettext("One of our friendly Meet & Greeters will welcome you and introduce you to the home."),
  JOURNEY_ERROR: gettext("Sorry, something went wrong trying to get your journey details."),
  HOW: gettext("We'd love to know how"),
  NO_THANKS: gettext("No thanks, I'm all set"),
  OOPS: gettext("Oops-a-daisy, we can't find that flight number."), 
  PUBLIC_TRANSPORT: gettext("Public Transport"),
  SELECT_AIRPORT: gettext("Select an airport"),
  SELECT_STATION: gettext("Select a station"),
  TRAIN_ARRIVAL_TIME: gettext("Train arrival time"),
  TRAIN_STATION: gettext("Train station"),
  TRAVEL_ARRANGEMENTS: gettext("Travel arrangements"),
  WHICH_STATION: gettext("Which station"),
  VEHICLE_LIMIT_WARNING: gettext("Please be aware that our airport transfer partner can take up to four passengers per vehicle. If you need a bigger taxi, drop us a line at"),
};

module.exports = function(config) {

  // transfer options
  const TransferField = React.createClass({
    render: function() {
      const {model} = this.props;
      const typeChoices = [
        ['public', messages.PUBLIC_TRANSPORT],
        ['private', messages.CAR_TAXI],
      ];
      const bookChoices = [
        ['yes', interpolate(messages.ADD_TO_BILL, {currency: config.currency_symbol, amount: model.transferAmount()}, true)],
        ['no', messages.NO_THANKS],
      ];

      let transferOptions;

      if(!model.hasTransferAmount()) {
        transferOptions = null;
      } else if(model.canOrganiseTransfer()) {
        transferOptions = <RadioField label={messages.ARRANGE_PICKUP} model={model} field="booked_transfer" choices={bookChoices} name="booked_  " />;
      } else {
        transferOptions = <p>{messages.VEHICLE_LIMIT_WARNING} <a href={"mailto:" + settings.cities[config.city_code].contact.guests.email}>{settings.cities[config.city_code].contact.guests.email}</a>.</p>;
      }

      return (
        <div>
          <RadioField label={messages.GET_TO_HOME} model={model} field="transfer_type" choices={typeChoices} name="transfer_type" disabled={this.props.disabled} />
          {transferOptions}
        </div>
      );
    }
  });

  // Text shown on successful flight lookup
  const FlightText = React.createClass({
    render: function() {
      const {model} = this.props;

      return (
        <div className="flight-details">
          {model.get('flight_airline')} flight {model.get('flight_number')}, departing {model.get('flight_departure_airport')} {' '} {model.get('flight_departure_time')}, arriving {model.get('airport')} {model.get('flight_eta')}
        </div>
      );
    }
  });

  var FlightCodeField = React.createClass({
    getInitialState: function() {
      return {
        flightNumber: this.props.model.get('flight_number') || null,
        loading: false,
        manual: false,
        invalid: false
      };
    },

    lookup: _.debounce(function() {
      $.ajax(config.flight_endpoint, {
        data: {flight_number: this.state.flightNumber},
        success: _.bind(function(data) {
          this.props.model.set(data);
          this.setState({
              loading: false,
              invalid: false
          });
        }, this),
        error: _.bind(function() {
          this.props.model.set({
            flight_airline: null,
            flight_number: null,
            flight_arrival_airport: null,
            flight_departure_airport: null,
            flight_departure_time: null
          });
          this.setState({
              loading: false,
              invalid: true
          });
        }, this)
      });
    }, 1000),

    handleChange: function(event) {
      const {value} = event.target;
      this.setState({flightNumber: value});
    },

    handleClick: function() {
      this.setState({loading: true});
      this.lookup();
    },

    render() {
      const {model, name, onManualFlightClick} = this.props;
      const {flightNumber, loading, invalid} = this.state;

      return (
        <FieldContainer label={messages.FLIGHT_NUMBER}>
          <Row>
            <Column size="three-quarters">
              <input className="flight-number" type="text" value={flightNumber} onChange={this.handleChange} id={name} />
            </Column>
            <Column size="quarter">
              <div className="ofs-PrestayArrival__CheckingStatus">
                {loading ? <span>{messages.CHECKING}</span> : <button className="ofs-Button ofs-Button--small ofs-Button--full-width" onClick={this.handleClick} disabled={flightNumber ? null : 'disabled'}>{messages.CHECK}</button>}
              </div>
            </Column>
          </Row>
          <div className="ofs-PrestayArrival__InputMessage">
            {!invalid && model.get('flight_number') ? <FlightText model={model} /> : null}
            {invalid ? <span>{messages.OOPS} <a href="javascript:void(0)" onClick={onManualFlightClick}>{messages.ENTER_MANUALLY}</a>.</span> : null}

          </div>
        </FieldContainer>
      );
    }
  });

  const ManualFlightDetails = React.createClass({
    render() {
      const {model} = this.props;
      const choices = config.airport_choices.slice(0).map((choice) => ({
          value: choice[0], 
          name: choice[1],
      }));

      const airport = model.travel.get('airport');

      return (
        <div className="manual-flight">
          <SelectField placeholder={messages.SELECT_AIRPORT} key="airport" label={messages.AIRPORT} name="airport" model={model.travel} field="airport" defaultValue={airport} options={choices} />
          <TimeField label={messages.FLIGHT_ARRIVAL_TIME} name="flight_eta" model={model.travel} field="flight_eta" />
          <TransferField model={model.travel} />
        </div>
      );
    }
  });


  const CalculatedFlightDetails = React.createClass({
    render() {
      const {model} = this.props;
      return (
        <div className="calculated-flight">
          <FlightCodeField model={model.travel} field="flight_number" name="flight_number" onManualFlightClick={this.props.onManualFlightClick} />
          <TransferField model={model.travel} />
        </div>
      );
    }
  });


  const FlightOptions = React.createClass({
    getInitialState() {
      const {model} = this.props;
      return {
        manual: model.travel.get('airport') && !model.travel.get('flight_number') ? true : false
      };
    },

    handleManualFlightClick() {
      this.props.model.travel.unset('flight_number');
      this.setState({
        manual: true
      });
    },

    render() {
      const {model} = this.props;

      return (
        <div className="flight-options">
          {!this.state.manual ? <CalculatedFlightDetails model={model} onManualFlightClick={this.handleManualFlightClick} /> : null}
          {this.state.manual ? <ManualFlightDetails model={model} /> : null}
        </div>
      );
    }
  });

  const TrainOptions = React.createClass({
    render() {
      const {model} = this.props;

      const choices = config.station_choices.slice(0).map((choice) => ({
          value: choice[0], 
          name: choice[1],
      }));

      const trainStation = model.travel.get('train_station');
      return (
        <div className="train-options">
          <SelectField placeholder={messages.SELECT_STATION} key="train_station" label={messages.TRAIN_STATION} name="train_station" model={model.travel} field="train_station" options={choices} defaultValue={trainStation}/>
          {trainStation && trainStation !== 'N/A' ? <div><TimeField label={messages.TRAIN_ARRIVAL_TIME} name="train_eta" model={model.travel} field="train_eta" /><TransferField model={model.travel} disabled={!model.travel.get('train_station') ? 'disabled' : null} /></div> : null}
          {trainStation === 'N/A' ? <div><TextField label={messages.WHICH_STATION} name="other_station" model={model.travel} field="other_station" /></div> : null}
        </div>
      );
    }
  });

  const OtherTransportOptions = React.createClass({
    render() {
      const {model} = this.props;

      return (
        <div className="other-transport-options">
          <TextField label={messages.HOW} name="other_method" model={model.travel} field="other_method" />
        </div>
      );
    }
  });
  const JourneySummary = React.createClass({
    handleDateChange(value) {
      this.props.model.set('arrival_date', value.format("YYYY-MM-DD"));
    },
    render() {
      const {model} = this.props;
      let journeyLegs;

      if (Array.isArray(model.get('journey'))) {
        journeyLegs = model.get('journey').map((leg) => {
          if (leg.delta === '0:00:00') {
            // End
            if (leg.leg === 'Arrival at home') {
              return (
                <li key={leg.leg} className="ofs-TravelTime__Item">
                  <Icon glyph="arrow" size="large" variant="right"/>
                  <div className="ofs-TravelTime__InfoWrapper">
                    <span className="ofs-TravelTime__Label">{leg.leg}</span>
                    <span className="ofs-TravelTime__Info">{moment(leg.end_time, "YYYY-MM-DDTHH:mm").format('HH:mm')}</span>
                    <span className="ofs-TravelTime__Label u-text-italic"></span>
                  </div>
                </li>
              );
            } else {
              return (
                <li key={leg.leg} className="ofs-TravelTime__Item">
                  <span className="ofs-TravelTime__Label">{leg.leg}</span>
                  <span className="ofs-TravelTime__Info">{moment(leg.end_time, "YYYY-MM-DDTHH:mm").format('HH:mm')}</span>
                  <span className="ofs-TravelTime__Label u-text-italic"></span>
                </li>
              );
            }

          } else {
            // It's an intermediate step
            const hour = moment(leg.delta, "YYYY-MM-DDTHH:mm").hours();
            const minute = moment(leg.delta, "YYYY-MM-DDTHH:mm").minutes();

            return (
              <li key={leg.leg} className="ofs-TravelTime__Item">
                <Icon glyph="arrow" size="large" variant="right"/>
                <div className="ofs-TravelTime__InfoWrapper">
                  <span className="ofs-TravelTime__Label">{leg.leg}</span>
                  <span className="ofs-TravelTime__Info">+{hour ? hour + 'h ' : null}{minute}min</span>
                  <span className="ofs-TravelTime__Label u-text-italic">Estimate</span>
                </div>
              </li>
            );
          }
        });
      }


      const currentDate = moment(model.travel.get('appointment_time'), "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");
      return (
        <div className="ofs-PrestayArrival__JourneySummary ">
          <h3>{messages.ARRIVAL_AT_THE_HOME}</h3>
          <ul className="ofs-TravelTime">{journeyLegs}</ul>
          <TimeField key="journey_eta"
            label={messages.DIFFERENT_ARRIVAL_TIME_AT_HOME}
            name="arrival_time"
            model={model} field="arrival_time" />
          {config.admin ? <Field label="Getting to the home on a different date? (admin)" adminOnly={true}>
            <Datepicker value={currentDate} name="arrival_appointment_date" handleSelect={this.handleDateChange} flux={window.ofsFlux} />
          </Field> : null }
        </div>
      );
    }
  });


  const CalculatedJourney = React.createClass({
    getInitialState() {
      return {
        loading: false,
        error: false
      };
    },

    handleDateChange(value) {
      this.props.model.set('arrival_date', value.format("YYYY-MM-DD"));
    },

    handleClick(event) {
      const {model} = this.props;
      event.preventDefault();
      this.setState({loading: true});

      const payload = JSON.stringify(model.travel.toJSON());

      $.post(config.journey_endpoint, {payload: payload})
        .done((data) => {
          model.set('arrival_time', data.eta);
          model.set('journey', data.journey);
          model.appointment.set('appointments', data.appointments);
          this.setState({loading: false});
        })
        .fail(() => {
          model.set('journey', true);
          this.setState({
            loading: false,
            error: true
          });
        });
    },

    render() {
      const {model} = this.props;

      if (this.state.error) {
        const currentDate = moment(this.props.model.travel.get('appointment_time'), "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");
        return (
          <div className="calculated-journey">
            <div className="ofs-Prestay__PlaceholderBox">
              <p>{messages.JOURNEY_ERROR}<br />{messages.ESTIMATE_YOUR_ARRIVAL_TIME}</p>
            </div>
            <TimeField key="journey_eta" label={messages.ESTIMATED_ARRIVAL} name="arrival_time" model={model} field="arrival_time" />
            {config.admin ? <Field label="Getting to the home on a different date? (admin)" adminOnly={true}>
              <Datepicker value={currentDate} name="arrival_appointment_date" handleSelect={this.handleDateChange} flux={window.ofsFlux} />
            </Field> : null }
          </div>
        );
      }
      return (
        <div className="calculated-journey">
          {model.get('journey') ? <JourneySummary model={model} /> : <div className="ofs-Prestay__PlaceholderBox">{this.state.loading ? 'Loading' : <button disabled={model.travel.canCalculateJourney() ? null : 'disabled'} className="ofs-Button small" onClick={this.handleClick}>{messages.CALCULATE_ARRIVAL}</button>}</div>}
        </div>
      );
    }
  });

  const ManualJourney = React.createClass({
    handleDateChange(value) {
      this.props.model.set('arrival_date', value.format("YYYY-MM-DD"));
    },
    render() {
      const {model} = this.props;
      const currentDate = moment(model.travel.get('appointment_time'), "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");
      return (
        <div className="manual-journey">
          <TimeField label={messages.ESTIMATED_ARRIVAL} name="arrival_time" model={model} field="arrival_time" />
          {config.admin ? <Field label="Getting to the home on a different date? (admin)" adminOnly={true}>
            <Datepicker value={currentDate} name="arrival_appointment_date" handleSelect={this.handleDateChange} flux={window.ofsFlux} />
          </Field> : null }
          <p>{messages.ESTIMATE}</p>
        </div>
      );
    }
  });

  const TransportOptions = React.createClass({
    render() {
      const {model} = this.props;

      const choices = [
        {value: 'plane', name: messages.FLYING_IN},
        {value: 'train', name: messages.BY_TRAIN},
        {value: 'car', name: messages.DRIVING},
        {value: 'other', name: messages.ANOTHER_METHOD},
      ];

      const choice = model.travel.get('transport_type');
      const label = interpolate(messages.GET_TO_CITY, {city: config.city}, true);

      return (
        <div className="transport-options">
          <div className="ofs-EditorialGrid">
            <div className="ofs-EditorialGrid__Column ofs-EditorialGrid__Column--big">
              <PhoneNumberField label={messages.ARRIVAL_MOBILE_NUMBER} name="arrival_phone" model={model} field="arrival_phone" />
              <SelectField key="transport_type" model={model.travel} field="transport_type" name="transport_type" label={label} options={choices} defaultValue={choice} />
              {!choice || choice === 'plane' ? <FlightOptions model={model} /> : null}
              {choice === 'train' ? <TrainOptions model={model} /> : null}
              {choice === 'other' ? <OtherTransportOptions model={model} /> : null}
              {!model.travel.shouldCalculateJourney() ? <ManualJourney model={model} /> : null}
            </div>
          </div>
          {model.travel.shouldCalculateJourney() ? <CalculatedJourney model={model} /> : null}
        </div>
      );
    }
  });

  const AppointmentWrapper = React.createClass({
    getInitialState() {
      return {
        loading: false
      };
    },

    modelChanged() {
      if (_.size(this.props.model.appointment.get('appointments')) > 0) {
        this.setState({
          loading: false,
        });
      }
    },

    componentDidMount() {
      this.props.model.on("change", _.bind(this.modelChanged, this));
    },

    componentWillUnmount() {
      this.props.model.off(null, null, this);
    },

    handleClick() {
      this.setState({loading: true});

      const eta = this.props.model.get('eta');
      $.post(
        config.appointments_endpoint, 
        {eta: eta}, 
        ((data) => {
          this.props.model.appointment.set('appointments', data.appointments);
          this.setState({loading: false});
        })
      );

    },

    render: function() {
      const {model} = this.props;
      const disabled = model.canFindAppointments() && model.get('eta') ? null: 'disabled';
      var appointments;

      if (model.appointment.get('appointments')){
        appointments = (<Appointments model={model} config={config}/>);
      } else {
        appointments = (
          <div className="ofs-Prestay__PlaceholderBox">
            {this.state.loading ? 'Loading' : <button className="ofs-Button ofs-Button--small" disabled={disabled} onClick={this.handleClick}>{messages.FIND_APPOINTMENTS}</button>}
          </div>
        );
      }

      return (
        <PrestayContentSection title="Your appointment">
          <p className="ofs-Prestay__ContentIntro">{messages.GREETERS_WILL_MEET}</p>
          <div className="appointments">
            {appointments}
          </div>
        </PrestayContentSection>
      );
    }
  });

  var Arrivals = React.createClass({
    componentDidMount() {
      this.props.model.on("change", this.forceUpdate.bind(this, null), this);
      this.props.model.travel.on("change", this.forceUpdate.bind(this, null), this);
      this.props.model.appointment.on("change", this.forceUpdate.bind(this, null), this);
    },

    componentWillUnmount() {
      this.props.model.off(null, null, this);
      this.props.model.travel.off(null, null, this);
      this.props.model.appointment.off(null, null, this);
    },

    render() {
      const {model, contact} = this.props;
      const appointment = model.appointment.get('selected_appointment');
      const isValid = model.travel.isValid() && model.appointment.isValid();
      let payload = model.travel.toJSON();

      payload['eta'] = model.get('eta');
      payload['arrival_phone'] = model.get('arrival_phone');

      if (appointment) {
        payload['appointment_type'] = appointment.type;
        payload['appointment_time'] = appointment.time;

        if (config.admin) {
          payload['appointment_place_type'] = model.appointment.get('appointment_place_type');
          if (model.appointment.get('appointment_place_type') === 'external') {
            payload['external_location'] = model.appointment.get('external_location');
            payload['external_address'] = model.appointment.get('external_address');
            payload['external_map_link'] = model.appointment.get('external_map_link');
          } else {
            payload['external_location'] = null;
            payload['external_address'] = null;
            payload['external_map_link'] = null;
          }
          payload['price_override'] = model.appointment.get('price_override');
        }
      }
      return (
        <form className="arrivals-form" method="post" action=".">
          <PrestayContentSection title={messages.TRAVEL_ARRANGEMENTS}>
            <input type="hidden" name="payload" value={JSON.stringify(payload)} />
            <TransportOptions model={model} />
          </PrestayContentSection>
          {model.canFindAppointments() || !model.travel.shouldCalculateJourney() ? <AppointmentWrapper model={model} /> : null}
          {config.admin ? <button className="ofs-Button admin-only button small" disabled={!isValid}>Save and continue</button> : <SaveButton models={[model.travel, model.appointment]} email={contact.guestServicesEmail} phone={contact.guestServicesPhone}/>}
        </form>
      );
    }
  });

  return {
    Arrivals: Arrivals
  };
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/arrival/views.jsx
 **/